import { useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { usePreferencesStore } from '@/store/useStore';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = usePreferencesStore();

  // Initial theme setup
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    
    // Debug logging
    console.log('Theme changed to:', theme);
    console.log('Document classes:', root.className);
  }, [theme]);

  // Ensure theme is applied on mount
  useEffect(() => {
    const root = window.document.documentElement;
    if (!root.classList.contains('light') && !root.classList.contains('dark')) {
      root.classList.add(theme);
      console.log('Initial theme applied:', theme);
    }
  }, []);

  return <>{children}</>;
}

export function ThemeToggle() {
  const { theme, toggleTheme } = usePreferencesStore();

  const handleToggle = () => {
    console.log('Theme toggle clicked, current theme:', theme);
    toggleTheme();
    console.log('Theme after toggle:', theme === 'light' ? 'dark' : 'light');
  };

  return (
    <button
      onClick={handleToggle}
      className="inline-flex items-center justify-center w-10 h-10 rounded-xl text-primary transition-all"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      data-testid="button-theme-toggle"
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5" />
      ) : (
        <Sun className="h-5 w-5" />
      )}
    </button>
  );
}
